
import React, {useState} from 'react'
import './Styles.css';
//import React, {useEffect, useState} from 'react'
// function Work(){
//     const [jobs, setJobs] = useState([]);
//     const [selectedJob, setSelectedJob] = useState(null);

//     useEffect(() => {
//         //fetch("http://localhost:8080/jobs")
//         // fetch("https://18.116.167.241:8080/jobs")
//         fetch("http://localhost:8080/jobs")
//             .then((response) => response.json())
//             .then((data=>setJobs(data)))
//             .catch((error) => console.error("Error fetching jobs: ", error));
//     }, []);
    
//     const handleButtonClick = (id) => {
//         // Have to use `, aka a backtick instead of '/" for the fetch url
//         // fetch(`http://localhost:8080/jobs/${id}`)
//         //fetch(`https://18.116.167.241:8080/jobs/${id}`)
//         fetch(`http://localhost:8080/jobs/${id}`)
//         .then((response)=> response.json())
//         .then((data) => setSelectedJob(data))
//         .catch((error) => console.error("Error fetching job: ", error));
//     };
//         return(
//             <section id = "Work">
//                 <h2>Work Experience</h2>
//                 <div>
//                     {jobs.map((job) => (
//                         <button
//                             key={job.id} 
//                             onClick={() => handleButtonClick(job.id)}
//                             style={{margin: "0.5rem",padding: "0.5rem 1rem"}}
//                         >
//                             {job.title}
//                         </button>
//                     ))}
//                 </div>
//                 {selectedJob && (
//                     <div style={{ marginTop: "1rem", 
//                                     padding: "1rem", 
//                                     border: "2px solid #ccc", }} >
//                         <h3> {selectedJob.title}</h3>
//                         {Array.isArray(selectedJob.description) ? (
//                             <ul>
//                             {selectedJob.description.map((point, index) => (
//                                 <li key={index}>{point}</li>
//                             ))}
//                             </ul>
//                         ) : (
//                             <p>{selectedJob.description}</p>
//                          )}
//                     </div> 
//                 )}
//             </section>
//         );
// }

function Work()
{   
    const jobs = [

        {
        id: 1, title: "Software Engineer II (Raytheon)", description: ["Prepared for program while awaiting clearance through self study"
                                                        
        ]
                                                    }, 
        {id: 2, title: "Software Engineer (Boeing)", description: ["Developed and tested software for the F-18 and MQ-25 processor product line", 
                                                        "Implemented an automated testing framework in C++ to support nightly testing",
                                                        "Modified a Python deployment capture script to load only required switch-interface files onto " +
                                                        "hardware, \r\n reducing flash utilization by 200 KBs, ram utilization by 1.75 MBs and load time by 25 seconds",
                                                        "Revised NSA testing procedures for the F-18 multi-level communication system",
                                                        "Participated in daily Agile stand-ups, sprint planning, and code reviews"]
                                                    },
        {id: 3, title: "Software Engineering Intern (Boeing)", description: ["Developed and supported Visual System Software for flight trainers",
                                                        " Collaborated with mentor to develop a Python API replacement for the Presagis API by using SWIG\r\n" + 
                                                        " to interface with a Boeing Radar Modeling Simulator written in C++",
                                                        " Participated in daily Agile standups, sprint planning and code reviews"]}

    ];
    const [selectedJob, setSelectedJob] = useState(null);
    const handleButtonClick = (job) => {
        setSelectedJob((prevJob) => (prevJob?.id === job.id ? null : job));
    };

    return (
        <section id="Work">
            <h2>Work Experience</h2>
            <div>
                {jobs.map((job) => (
                    <button
                        key={job.id}
                        onClick={() => handleButtonClick(job)}
                        style={{
                            margin: "0.5rem",
                            padding: "0.5rem 1rem",    
                            backgroundColor: selectedJob?.id === job.id ? "#f4dfce" : "transparent",
                            fontSize: "1rem",
                            cursor: "pointer",
                        
                        }}
                    >
                        {job.title}
                    </button>
                ))}
            </div>

            <div className={`content-wrapper ${selectedJob ? "open" : ""}`}>
                <div className="content">
                    {selectedJob && (
                        <>
                            <h3>{selectedJob.title}</h3>
                            {Array.isArray(selectedJob.description) ? (
                                <ul>
                                    {selectedJob.description.map((point, index) => (
                                        <li key={index}>{point}</li>
                                    ))}
                                </ul>
                            ) : (
                                <p>{selectedJob.description}</p>
                            )}
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Work;